import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ErrorMessages } from '../../../../common/components';
import { ChildPageHeading } from '../../../../common/components/ChildPageHeading';
import { Routes } from '../../../../config/routes';
import { useTranslations } from '../../../../contexts/LocalizationContext';
import { useCreateNewsNew } from '../../../../services/news-new';
import { NewsNewForm } from '../NewsNewForm/NewsNewForm';

export const CreateNewsNew = () => {
  const translations = useTranslations();
  const navigate = useNavigate();
  const { mutate: createNews, isLoading, error } = useCreateNewsNew();

  return (
    <>
      <ChildPageHeading>{translations('news_new_create')}</ChildPageHeading>
      <ErrorMessages errors={error} />
      <NewsNewForm
        isLoading={isLoading}
        onSubmit={(createNewsRequest) =>
          createNews(createNewsRequest, {
            onSuccess: () => navigate(Routes.NEWS_NEW_PATH),
          })
        }
      />
    </>
  );
};
